<template>
  <div>
    <div class="mb-4 flex justify-between items-center">
      <h2 class="text-lg font-semibold text-gray-900">Patient Attribution Records</h2>
      <ExportMenu
        :disabled="!rowData.length"
        :exports="[{ type: 'excel', action: exportToExcel }]"
      />
    </div>

    <div style="height: 500px;">
      <AgGridVue
        :theme="compactListTheme"
        style="width: 100%; height:100%"
        :column-defs="columnDefs"
        :row-data="rowData"
        :default-col-def="defaultColDef"
        :grid-options="gridOptions"
        :loading="loading"
        @grid-ready="onGridReady"
      />

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { AgGridVue } from 'ag-grid-vue3';
import {compactListTheme} from '@/utils/common';
import ExportMenu from '@/components/widgetcomponents/library/ExportMenu.vue';

export default defineComponent({
  name: 'Patient_Attribution_Table',
  computed: {
    compactListTheme() {
      return compactListTheme
    },
  },
  components: {
    AgGridVue,
    ExportMenu,
  },
  props: {
    patientIdentifier: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      rowData: [],
      gridApi: null,
      gridOptions: {
        suppressAggFuncInHeader: true,
        domLayout: this.autoHeight ? 'autoHeight':null
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },

      columnDefs: [
        {
          headerName: 'Patient Identifier',
          field: 'patient_identifier_combined',
          valueGetter: params => {
            const mbiId = params.data.bene_mbi_id;
            const otherId = params.data.other_patient_identifier;

            if (mbiId && otherId) {
              return `${mbiId} / ${otherId}`;
            } else if (mbiId) {
              return mbiId;
            } else if (otherId) {
              return otherId;
            }
            return '';
          }
        },
        {
          field: 'report_dt',
          headerName: 'Report Date',
          valueFormatter: this.dateFormatter,
        },
        {
          field: 'contract_id',
          headerName: 'Contract ID',
        },


        {
          field: 'report_type',
          headerName: 'Report Type',
        },
        {
          field: 'attribution_start_date',
          headerName: 'Attribution Start',
          valueFormatter: this.dateFormatter,
        },
        {
          field: 'attribution_end_date',
          headerName: 'Attribution End',
          valueFormatter: this.dateFormatter,
        },
        {
          field: 'performance_year',
          headerName: 'Performance Year',
          width: 140
        },
        {
          field: 'report_rank',
          headerName: 'Report Rank',
          sort:'asc'
        }
      ]
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;

      try {
        const response = await axios.post('api/returnpatientdata/', {
          data_type: 'attrib',
          patient_identifier: this.patientIdentifier,
          attribution_type : 'attribution_history'
        });

        this.rowData = response.data || [];
      } catch (error) {
        console.error('Error fetching attribution data:', error);
        this.rowData = [];
      } finally {
        this.loading = false;
      }
    },

    onGridReady(params) {
      this.gridApi = params.api;
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', this.onWindowResize);

    },

    exportToExcel() {
      if (this.gridApi) {
        if (this.$root?.isDemoMode) return; // Demo Mode: block raw-data export
        this.gridApi.exportDataAsExcel({
          fileName: `patient_attribution_${this.patientIdentifier}_${new Date().toISOString().split('T')[0]}.xlsx`,
          sheetName: 'Attribution'
        });
      }
    },
    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    dateFormatter(params) {
      if (!params.value) return '';
      const date = new Date(params.value + 'T00:00:00');
      if (isNaN(date)) return params.value;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  },
  mounted() {
    this.fetchData();
  }
});
</script>

<style scoped>

</style>
